import axios from 'axios';
// import store from '../store';

// function errorHandler(error, reject) {
//     console.log(error);
//     if (error.response && error.response.data) {
//         reject(error.response.data);
//     } else {
//         reject(error);
//     }
// }
function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        const err = error.response.data;
        if ((err.name=="JsonWebTokenError") || (err.message=="jwt malformed")) { 
            const redirectPath = localStorage.getItem('redirectPath');
            window.localStorage.clear();
            if (redirectPath) localStorage.setItem('redirectPath',redirectPath);
            window.location.reload();
        } else if ((err.name=="TokenExpiredError") || (err.message=="jwt expired")) { 
            const redirectPath = localStorage.getItem('redirectPath');
            window.localStorage.clear();
            if (redirectPath) localStorage.setItem('redirectPath',redirectPath);
            window.location.reload();
        }
        reject(error.response.data);
    } else {
        reject(error);
    }
}

function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'DimColName', 'kode', 'nama', 'aktif'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/dimsample${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function lookup(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'DimColName', 'kode', 'nama','aktif'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/dimsample/lookup${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}
function dimsetup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/dimsample/dimsetup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function update(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const obj = {
                DimColName: data.DimColName,
                kode: data.kode,
                nama: data.nama,
                aktif: data.aktif || 0
            };
            await axios.put(`dimsample/${data.idrowunik}`, obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function insert(data) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("dimsample", data);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`dimsample/${obj.idrowunik}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function exportxls(obj = {}) {
    const keys = [ 'sortBy', 'sortDir', 'DimColName','DimColInfo', 'kode', 'nama', 'aktif'];

    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }

    axios({
        url: `/dimsample/exportxls${str}`,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '_list_dimension_value.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
    });

}

export default {
    list, lookup,
    dimsetup,
    insert,
    update,
    remove,
    exportxls
};